import { render, staticRenderFns } from "./SituacionLaboralList.vue?vue&type=template&id=972e74dc"
import script from "./SituacionLaboralList.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports